// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-loading-skeleton {
  grid-column: 1/-1;
  display: grid;
  gap: 16px;
}

.dashboard-loading-skeleton__kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.dashboard-loading-skeleton__panels {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.dashboard-loading-skeleton__block {
  position: relative;
  overflow: hidden;
  min-height: 122px;
  border: 1px solid #dbe2ea;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
}

.dashboard-loading-skeleton__block--panel {
  min-height: 380px;
}

.dashboard-loading-skeleton__block::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(226, 232, 240, 0.65) 50%, rgba(255, 255, 255, 0) 100%);
  animation: dashboard-skeleton-shimmer 1.2s ease-in-out infinite;
}

@keyframes dashboard-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
@media (max-width: 1200px) {
  .dashboard-loading-skeleton__kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-loading-skeleton__panels {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/DashboardStates/DashboardStates.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;EACA,yHAAA;EAMA,+DAAA;AAJF;;AAOA;EACE;IACE,2BAAA;EAJF;AACF;AAOA;EACE;IACE,gDAAA;EALF;EAQA;IACE,0BAAA;EANF;AACF","sourcesContent":[".dashboard-loading-skeleton {\n  grid-column: 1 / -1;\n  display: grid;\n  gap: 16px;\n}\n\n.dashboard-loading-skeleton__kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.dashboard-loading-skeleton__panels {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 22px;\n}\n\n.dashboard-loading-skeleton__block {\n  position: relative;\n  overflow: hidden;\n  min-height: 122px;\n  border: 1px solid #dbe2ea;\n  border-radius: 6px;\n  background: #ffffff;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);\n}\n\n.dashboard-loading-skeleton__block--panel {\n  min-height: 380px;\n}\n\n.dashboard-loading-skeleton__block::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(226, 232, 240, 0.65) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: dashboard-skeleton-shimmer 1.2s ease-in-out infinite;\n}\n\n@keyframes dashboard-skeleton-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@media (max-width: 1200px) {\n  .dashboard-loading-skeleton__kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .dashboard-loading-skeleton__panels {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
